import React, { useState } from "react";
// External Components
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/styles";
import { useMediaQuery } from "@mui/material";
// Icons
import ArrowDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowUpIcon from "@mui/icons-material/ArrowDropUp";
import AccountCircleIcon from "@mui/icons-material/AccountCircleRounded";
// Internal Components
import useStyles from "./useStyles";
var AccountInfoButton = function (_a) {
    var email = _a.email, children = _a.children;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var breakpoints = useTheme().breakpoints;
    var isMdUp = useMediaQuery(breakpoints.up("md"));
    var onClick = function (_a) {
        var currentTarget = _a.currentTarget;
        setOpen(!open);
        setAnchorEl(currentTarget);
    };
    var closeMenu = function () {
        setOpen(false);
        setAnchorEl(null);
    };
    var classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: onClick, variant: "text", color: "secondary" },
            isMdUp && React.createElement(AccountCircleIcon, null),
            React.createElement(Typography, { className: classes.accountEmail, noWrap: true }, email),
            open ? (React.createElement(ArrowUpIcon, { "aria-label": "Open user menu" })) : (React.createElement(ArrowDownIcon, { "aria-label": "Close user menu" }))),
        React.createElement(Menu, { anchorEl: anchorEl, open: open, onClose: closeMenu, onClick: closeMenu, anchorOrigin: {
                vertical: "bottom",
                horizontal: "center",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "center",
            } }, children)));
};
export default AccountInfoButton;
//# sourceMappingURL=index.js.map